import * as R from "ramda";
import { call, reducer } from "../../helpers/api/meta";
import { getAllClasses, getClassroomByClassId } from "../../helpers/api/api";

export const GET_CLASSES_DATA = "GET_CLASSES_DATA";

export const callGetAllClasses = (inputs) => {
  const meta = {
    endpoint: (params) => getAllClasses(params),
    inputs,
    action: GET_CLASSES_DATA,
    messages: {
      id: "getClasses",
      failure: "Could not get classes.",
    },
  };
  return call(meta);
};
export const callGetClassroomClassById = (inputs) => {
  const meta = {
    endpoint: (params) => getClassroomByClassId(params),
    inputs,
    action: GET_CLASSES_DATA,
    messages: {
      id: "getClasses",
      failure: "Could not get classes by class ID.",
    },
  };
  return call(meta);
};

const initialState = {
  loading: false,
  results: [],
  count: 0,
  next: null,
  previous: null,
};

const messages = {
  loadFailed: "Could not load classes.",
};

const saveClasses = (state, action) => {
  return R.assoc("results", action, state);
};

export default reducer(
  initialState,
  GET_CLASSES_DATA,
  saveClasses,
  messages.loadFailed
);
